module.exports = __webpack_public_path__ + "img/oddnary-variation-1.85784ded.jpg";